import { css } from '@emotion/react';
import { styled } from '@mui/material';

import { StyledModalStack } from '@/components/management/form/formHelpers/StyledModalStack';

export const StyledModal = styled(StyledModalStack)(
  ({ theme }) => css`
    height: fit-content;
    gap: ${theme.spacing(4)};
    width: 50%;
  `,
);
